// Third Party Libraries Imports
import toast from "react-hot-toast";
import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";

// Local Imports
import { LOADING } from "../../store/actions";
import instance from "../../store/axios";
import { PortfoliosListApiResponse } from "../login/types";

class PortfoliosService {
  private dispatch = useDispatch();

  public async getPortfoliosListData(
    status: string[],
    all = false,
    page,
    searchWord,
    sortField,
    sortOrder,
    filters: any,
    source?: string[],
  ): Promise<
    | {
      data: PortfoliosListApiResponse;
      message: string;
    }
    | undefined
  > {
    this.dispatch({ type: LOADING, payload: true });
    let query: string = `?page=${page}&pageSize=20`;

    if (all) query += "&all=true";

    if (searchWord) {
      query += `&search=${searchWord}`;
    }
    if (sortField) {
      query += `&sortField=${sortField}`;
    }
    if (sortOrder) {
      query += `&sortOrder=${sortOrder === "ascend" ? "asc" : "desc"}`;
    }
    if (filters?.length && filters != "null") {

      JSON.parse(filters)?.forEach((element: string, index: number) => {
        if (index === 0) {
          query += `&status[${index}]=${element}`;
        } else {
          query += `&status[${index}]=${element}`;
        }
      });
    } else {
      status.forEach((element: string, index: number) => {
        if (index === 0) {
          query += `&status[${index}]=${element}`;
        } else {
          query += `&status[${index}]=${element}`;
        }
      });
    }

    if (source?.length) {
      source.forEach((element: string, index: number) => {
        if (index === 0) {
          query += `&source[${index}]=${element}`;
        } else {
          query += `&source[${index}]=${element}`;
        }
      });
    }

    try {
      const response: AxiosResponse<{
        data: PortfoliosListApiResponse;
        message: string;
      }> = await instance.get(`/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio${query}`);
      return response.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", "/portfolio");
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async regeneratePortfolioPdf(portfolioId: number, viewOnly: boolean, asOfDate: string): Promise<any> {
    this.dispatch({ type: LOADING, payload: true });
    try {
      const response: AxiosResponse<any> = await instance.post(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio/regeneratePortfolioPdf/${portfolioId}`,
        { portfolioId, viewOnly, asOfDate }
      );
      toast.success(response.data?.message || "PDF regenerated successfully");
      return response.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "Failed to regenerate PDF");
      }
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }
}

export default PortfoliosService;
